import React, { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroSection from './components/HeroSection';
import FamilyTimeline from './components/FamilyTimeline';
import TraditionalRecipes from './components/TraditionalRecipes';
import BakingProcess from './components/BakingProcess';
import CommunityImpact from './components/CommunityImpact';
import HeritageGallery from './components/HeritageGallery';

const OurItalianStory = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-20">
        <HeroSection />
        <FamilyTimeline />
        <TraditionalRecipes />
        <BakingProcess />
        <CommunityImpact />
        <HeritageGallery />
      </main>

      <Footer />
    </div>
  );
};

export default OurItalianStory;